import React from "react"
import { Helmet } from "react-helmet"
import Layout from "components/Layout"
import { compose } from "redux"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import reducer from "./reducer"
import saga from "./saga"
import "./index.less"

import {
  makeSelectAmbassadorDivisions,
  makeSelectDashboardData,
  makeSelectIsLoadingDashboardData,
  makeSelectSelectedDivision,
} from "./selectors"

import {
  getAmbassadorDivisionsWatcher,
  getReportsDashboardDataWatcher,
} from "./actions"

import arrow from "images/blue-right-arrow.svg"
import emptyResult from "images/empty-result-dashboard.svg"
import emptyEvolution from "images/empty-evolution-dashboard.svg"

import ReportCard from "./reportCard"
import { defaultTo, get, has, map } from "lodash"

import DashboardEmptyState from "./emptyStates/dashboardEmptyState"
import Loader from "../../components/Loader"
import { isLeader, isAmbassador, isAmbassadorActive, LOCAL_USER_ID, setItem, LOCAL_AMBASSADOR_ID, clearStorage, LOCAL_USER_ROLES_TEXT, KEY_USER_ID, KEY_USER_NAME, KEY_USER_PHOTO, KEY_MODULES, KEY_ACTIVE_ROL, KEY_AMBASSADOR_ID, isAdmin } from "../../utils/storage"
import { Button, Select, Space } from "antd"
import { loadTexts, sanitize } from "../../utils/i18n"
import { ROLE_AMBASSADOR, ROLE_LEADER, TYPE_SURVEY } from "../../utils/constants"
import { RoleSelector } from "../RoleSelector"
import AdminiIframeBanner from "../../components/AdminIframeBanner"


const { Option } = Select

export class ReportDashboard extends React.Component {
  intl = loadTexts("reports_dashboard")
  state = {
    selectedDivision: null,
  }

  onEnterIndicatorReport = (id_survey_type, id_measure) => {
    const { history } = this.props
    if (isAmbassadorActive() && id_survey_type === TYPE_SURVEY.climate.idSurveyType) {
      history.push(
        `/reports/measure/${id_survey_type}/${id_measure}?id_divisionParent=${this.state.selectedDivision}&id_division=${this.state.selectedDivision}`
      )
    } else {
      history.push(`/reports/measure/${id_survey_type}/${id_measure}`)
    }
  }

  componentDidMount = () => {
    if (isAmbassadorActive()) {
      this.props.getAmbassadorDivisionsWatcher()
    } else {
      this.props.getReportsDashboardDataWatcher()
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { ambassadorDivisions } = this.props
    if (
      ambassadorDivisions.length > 0 &&
      prevProps.ambassadorDivisions.length !== ambassadorDivisions.length
    ) {
      const firstDivisionID =
        ambassadorDivisions.length > 0
          ? ambassadorDivisions[0].id_division
          : null
      if (firstDivisionID) {
        this.setState({ selectedDivision: firstDivisionID })
        this.props.getReportsDashboardDataWatcher({
          id_division: firstDivisionID,
        })
      }
    }
  }

  

  render = () => {
    const {
      dashboardData,
      isLoadingDashboardData,
      ambassadorDivisions,
      selectedDivision,
    } = this.props
    let indicators = get(dashboardData, "indicators", [])
    const fullDate = defaultTo(
      dashboardData.last_process,
      "01/01/2021 00:00:00"
    )
    const fullDateArray = fullDate.split(" ")
    const date = fullDateArray[0]
    const time = fullDateArray[1]
    const thisTime = time.split(":")
    const suffix = thisTime[0] >= 12 ? "p.m." : "a.m."
    var hour = thisTime[0] > 12 ? thisTime[0] - 12 : thisTime[0]
    hour = hour < 10 ? `${hour}` : hour
    const min = thisTime[1]
    const newTime = `${hour}:${min} ${suffix}`
    // const indicators = []
    const hasLeaderRole = isLeader()
    const hasAmbassadorRole = isAmbassador()


    const hash = sessionStorage.getItem("hash")
    const withoutSpace= ambassadorDivisions.length <= 1 &&  window.top!== window.self
    return (
      <Layout>
        <Helmet>
          <title>{this.intl.dashboard.titlePage}</title>
          <meta name="description" content="Reports Dashboard" />
        </Helmet>
        <>
          {(isAdmin() && (window.top !== window.self)) && <AdminiIframeBanner adminHash={hash} />}
          <div className="reports-dashboard-container">
            <div className="reports-dashboard-header-flexbox">
              <div className="reports-dashboard-header-flexbox-item-start">
                <div className="reports-dashboard-title">
                  {this.intl.dashboard.title}
                </div>
                <div className="reports-dashboard-description">
                  {sanitize(this.intl.dashboard.description)}
                </div>
                <RoleSelector sourcePage="reports"/>
              </div>
              <div className="reports-dashboard-header-flexbox-item-end">
                {dashboardData.last_process && (
                  <div className="reports-dashboard-date">
                    {this.intl.dashboard.lastProcess.section1}
                    {date}
                    {this.intl.dashboard.lastProcess.section2}
                    {newTime}
                  </div>
                )}
              </div>
            </div>
            <div
              className={`${
                ambassadorDivisions.length > 1
                  ? "reports-dashboard-body-container"
                  : "reports-dashboard-body-container-small"
              } ${window.top!== window.self ? "deleteTop" : ""}`}>
              {isLoadingDashboardData ? (
                <Loader />
              ) : (
                <>
                  {isAmbassadorActive() && !withoutSpace && (
                    <>
                      <Space direction="horizontal">
                        {ambassadorDivisions.length > 1 && (
                          <div
                            style={{
                              fontWeight: "600",
                              fontStyle: "normal",
                              fontSize: "14px",
                              color: "#4F4F4F",
                            }}>
                            {this.intl.dashboard.divisionSelector}
                          </div>
                        )}
                        {ambassadorDivisions.length > 1 && (
                          <Select
                            style={{ width: "200px" }}
                            defaultValue={selectedDivision}
                            onChange={(e) => {
                              this.setState({ selectedDivision: e })
                              this.props.getReportsDashboardDataWatcher({
                                id_division: e,
                              })
                            }}>
                            {ambassadorDivisions.map((x) => (
                              <Option key={x.id_division} value={x.id_division}>
                                {x.name}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </Space>
                      <br />
                    </>
                  )}
                  <div className="cards-container">
                    {indicators.length === 0 && (
                      <DashboardEmptyState {...this.props} />
                    )}
                    {map(indicators, (indicator) => (
                      <ReportCard
                        key={indicator.id_survey_type}
                        onEnterIndicatorReport={this.onEnterIndicatorReport}
                        data={indicator}
                      />
                    ))}
                  </div>
                </>
              )}
            </div>
            
          </div>
        </>
      </Layout>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  dashboardData: makeSelectDashboardData(),
  isLoadingDashboardData: makeSelectIsLoadingDashboardData(),
  ambassadorDivisions: makeSelectAmbassadorDivisions(),
  selectedDivision: makeSelectSelectedDivision(),
})

function mapDispatchToProps(dispatch) {
  return {
    getReportsDashboardDataWatcher: (params) =>
      dispatch(getReportsDashboardDataWatcher(params)),
    getAmbassadorDivisionsWatcher: (params) =>
      dispatch(getAmbassadorDivisionsWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "reportsDashboard", reducer })
const withSaga = injectSaga({ key: "reportsDashboard", saga })

export default compose(withReducer, withSaga, withConnect)(ReportDashboard)
